import comm from "../assets/comm.js";
import Vue from "vue";

export default function pcLinkMobile() {
    const browserType = comm.browserType();
    if (!browserType.isPC) {
        let linkToHref = "";
        let mobileUrl = "//en.m.manamana.net";
        if (window.location.hash !== '#!en') {
            mobileUrl = '//m.manamana.net';
        }
        let pathname = window.location.pathname;
        switch (true) {
            case pathname === "/article": //$t('global.讨论区')
                linkToHref =
                    mobileUrl + `/articleIndex`;
                break;
            case pathname.includes('/article/detail'): //$t('global.讨论区')
                linkToHref =
                    mobileUrl + pathname.replace(`/article/detail`, '/questionDetail');
                break;
            case pathname === "/video/detail": //$t('global.视频详情页')
                linkToHref =
                    mobileUrl + "/VideoPlayer?videoId=" + comm.getUrlParam("id");
                break;
            case pathname === "/login": //$t('global.登陆页面')
                linkToHref = mobileUrl + "/login";
                break;
            case pathname === "/emailink": //email$t('global.认证页面')
                const type = comm.getUrlParam("type");
                if (type === '1' || type === '3') {
                    linkToHref = mobileUrl + "/login";
                } else {
                    linkToHref = mobileUrl + "/resetPassword" + location.search;
                }
                break;
            /**兼容一些老版本跳转 */
            case pathname === "/peopleCenter"://$t('global.个人中心')
                linkToHref = mobileUrl + "/otherPeople?userId=" + comm.getUrlParam("userId");
                break;
            /**兼容一些老版本跳转 */
            case /^\/peopleCenter/.test(pathname):
                linkToHref =
                    mobileUrl + "/otherPeople?userId=" + pathname.split('peopleCenter/')[1].split('/')[0];
                break;
            /**兼容消息通知--start */
            case pathname === '/subjectdetail':
                linkToHref =
                    mobileUrl + "/topicIntroduce?topicId=" + comm.getUrlParam("id");
                break;
            /**兼容消息通知--end */
            case /^\/subjectdetail|\/subjectDetail/.test(pathname):
                linkToHref =
                    mobileUrl + "/topicIntroduce?topicId=" + pathname.toLocaleLowerCase().split('subjectdetail/')[1].split('/')[0];
                break;
            case /^\/activityDetail/.test(pathname):
                linkToHref = mobileUrl + window.location.pathname.replace('activityDetail', 'ActivityDetail');
                break;
            case /^\/activity\/\d*\/detail$/.test(pathname):
                let str = window.location.pathname;
                str = str
                    .replace("/detail", "")
                    .replace("/activity", "/ActivityDetail");
                linkToHref = mobileUrl + str;
                break;
            case /^\/match\//.test(pathname):
            case /^\/event\//.test(pathname):
                linkToHref = mobileUrl + pathname;
                break;
            default:
                linkToHref = mobileUrl + location.pathname + location.search;
                break;
        }
        const auth_token = Vue.prototype.$storage.get("auth_token");
        if (auth_token) {
            if (linkToHref.indexOf("?") > -1) {
                linkToHref += "&auth_token=" + auth_token;
            } else {
                linkToHref += "?auth_token=" + auth_token;
            }
        }
        window.location.href = linkToHref;
    }
}



// WEBPACK FOOTER //
// ./src/util/mobileLink.js